import React from "react";
import PieChart from "../../../../components/charts/pieChart/pieChart";
import { useSelector } from "react-redux";

const MembershipBreakdownPieChart = () => {
  const data = useSelector((state) => state.membershipBreakdown.membershipsPieChartValues);
  const organization_name = useSelector(
    (state) => state.commonReducer.commonProps.organization_name
  );

  return (
    <PieChart
      showPercent
      data={data}
      isClubPilates={organization_name === "Club Pilates"}
      showLegend
      legendPosition="right"
    />
  );
};

export default MembershipBreakdownPieChart;
